import {
  CatalystInsight,
  CatalystInsightCategory,
  CatalystInsightFilterRequest,
  EarningsInsight,
  EarningsInsightsFilterRequest,
  KgInsightCategory,
  KgInsightFilterRequest,
  KgInsightFilterResponse,
} from '@api';

const catalystToKgCategory: Record<CatalystInsightCategory, KgInsightCategory> =
  {
    company: 'company_catalyst',
    market_wide: 'market_catalyst',
  };

const kgToCatalystCategory: Partial<
  Record<KgInsightCategory, CatalystInsightCategory>
> = {
  company_catalyst: 'company',
  market_catalyst: 'market_wide',
};

export const mapCatalystFilterRequestToKgFilterRequest = (
  payload: CatalystInsightFilterRequest
): KgInsightFilterRequest => {
  const subjects: NonNullable<KgInsightFilterRequest['subjects']> = [
    ...(payload.entities?.map(id => ({ type: 'entity' as const, id })) ?? []),
    ...(payload.themes?.map(id => ({ type: 'theme' as const, id })) ?? []),
  ];

  return {
    categories: payload.categories?.map(
      category => catalystToKgCategory[category]
    ),
    subjects: subjects.length > 0 ? subjects : undefined,
    from: payload.from,
    to: payload.to,
    page: payload.page,
    page_size: payload.page_size,
  };
};

export const mapKgInsightToCatalystInsight = (
  kgInsight: KgInsightFilterResponse[number]
): CatalystInsight => ({
  id: kgInsight.id,
  category: kgToCatalystCategory[kgInsight.category] ?? 'company',
  identifier: kgInsight.subject.id,
  title: kgInsight.title,
  sub_category: kgInsight.sub_category!,
  action_type: kgInsight.subtitle,
  created_at: kgInsight.created_at,
  updated_at: kgInsight.updated_at,
});

export const mapKgInsightToEarningsInsight = (
  kgInsight: KgInsightFilterResponse[number]
): EarningsInsight => ({
  id: kgInsight.id,
  type: kgInsight.category === 'earnings_recap' ? 'recap' : 'preview',
  title: kgInsight.title,
  earnings_id: kgInsight.subject.ref?.id ?? '',
  entity_tag: kgInsight.subject.type === 'entity' ? kgInsight.subject.id : '',
  created_at: kgInsight.created_at,
  updated_at: kgInsight.updated_at,
});

export const mapEarningsInsightsFilterRequestToKgFilterRequest = (
  payload: EarningsInsightsFilterRequest
): KgInsightFilterRequest => {
  return {
    categories: ['earnings_recap', 'earnings_preview'],
    subjects: payload.entities?.map(id => ({ type: 'entity' as const, id })),
    subject_refs: payload.earnings_ids?.map(id => ({
      type: 'earnings',
      id,
    })),
    from: payload.from,
    to: payload.to,
    page: payload.page,
    page_size: payload.page_size,
  };
};
